import { Injectable } from '@angular/core';

export interface GtmData {
  [key: string]: any;
}

@Injectable({
  providedIn: 'root',
})
export class GtmService {
  public triggerEvent(
    action: string,
    label: string,
    categoria: string,
    optional?: any
  ) {
    this.trigger('evento-interactivo', {
      'evento-interactivo-categoria': categoria,
      'evento-interactivo-accion': action,
      'evento-interactivo-etiqueta': label,
      ...optional,
    });
  }
  public triggerPageView(page: string, pageName: string = '', optional?: any ) {
    this.trigger('pagina-virtual', {
      page,
      pagename: pageName,
      ...optional,
    });
  }
  private async push(data: GtmData) {
    await (window as any).dataLayer.push(data);
  }

  private trigger(event: string, data?: GtmData) {
    this.push({
      event,
      ...data,
    });
  }
}
